<template>
  <div class="util-latest-list">
    <div class="util-card" v-for="(row,i) in listdata" :key="i">
      <div class="util-card-date">
        <strong>{{ dayjs(row.date).format("D") }}</strong>
        <span>{{ dayjs(row.date).format("MMM") }}</span>
        <span>{{ dayjs(row.date).format("YYYY") }}</span>
      </div>
      <div class="util-card-detail ucdg">
        <div class="ucdg-item">
          <span>Sumur 1</span>
          <p>
            <strong>{{ nom(row.meteran_1) }}</strong> m<sup>3</sup>
          </p>
        </div>
        <div class="ucdg-item">
          <span>Sumur 2</span>
          <p>
            <strong>{{ nom(row.meteran_2) }}</strong> m<sup>3</sup>
          </p>
        </div>
        <div class="ucdg-item">
          <span>Sumur 3</span>
          <p>
            <strong>{{ nom(row.meteran_3) }}</strong> m<sup>3</sup>
          </p>
        </div>
        <div class="ucdg-item">
          <span>Sumur 4</span>
          <p>
            <strong>{{ nom(row.meteran_4) }}</strong> m<sup>3</sup>
          </p>
        </div>
        <div class="ucdg-item">
          <span>Total Air</span>
          <p class="pgreen"> 
            <strong>{{ nom(row.total) }}</strong> m<sup>3</sup>
          </p>
        </div>

      </div>
    </div>
  </div>
</template>


<script lang="js">
import Vue from "vue";
import dayjs from "dayjs";
import { Prop } from "vue-property-decorator";
import { Component } from "vue-property-decorator";
import { nom  } from "@/api/api";
@Component({})
export default class UtilitiesListrikList extends Vue {
  @Prop () listdata;
  dayjs = dayjs
  nom = nom
}
</script>
